<template><SimpleModuleDashboard :module-id="Modules.CONTABILIDAD" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'accountPlan', reference: 'accountPlan', route: 'AccountingStaffAccountPlan', tone: 'primary', group: 'Configuraciones' },
  { id: 'accountingEntries', reference: 'accountingEntries', route: 'AccountingStaffAccountingEntries', tone: 'primary' },
  { id: 'accountingLedger', reference: 'accountingLedger', route: 'AccountingStaffAccountingLedger', tone: 'primary' },
  { id: 'accountingClosing', reference: 'accountingClosing', route: 'AccountingStaffAccountingClosing', tone: 'primary' },
  { id: 'settings', reference: 'settings', route: 'AccountingStaffSettings', tone: 'primary', group: 'Configuraciones' },
] }) }
</script>
